module.exports = __webpack_public_path__ + "static/media/bkash-wt.bdb25bdd.png";